// This file is part of React-Invenio-Deposit
// Copyright (C) 2020 CERN.
// Copyright (C) 2020 Northwestern University.
//
// React-Invenio-Deposit is free software; you can redistribute it and/or modify it
// under the terms of the MIT License; see LICENSE file for more details.

export const FILE_UPLOAD_IN_PROGRESS = 'FILE_UPLOAD_IN_PROGRESS';
export const FILE_UPLOAD_START = 'FILE_UPLOAD_START';
export const FILE_UPLOAD_FINISHED = 'FILE_UPLOAD_FINISHED';
export const FILE_UPLOAD_FAILED = 'FILE_UPLOAD_FAILED';

export const FILE_IMPORT_STARTED = 'FILE_IMPORT_STARTED';
export const FILE_IMPORT_SUCCESS = 'FILE_IMPORT_SUCCESS';
export const FILE_IMPORT_FAILED = 'FILE_IMPORT_FAILED';

export const FILE_DELETED_SUCCESS = 'FILE_DELETED_SUCCESS';
export const FILE_DELETE_FAILED = 'FILE_DELETE_FAILED';

export const FILE_UPLOAD_SET_CANCEL_FUNCTION =
  'FILE_UPLOAD_SET_CANCEL_FUNCTION';
export const FILE_UPLOAD_CANCELLED = 'FILE_UPLOAD_CANCELLED';
export const FILE_UPLOAD_INITIATE = 'FILE_UPLOAD_INITIATE';

// Actions
export const ACTION_CREATE_SUCCEEDED = 'ACTION_CREATE_SUCCEEDED';
export const ACTION_DELETE_FAILED = 'ACTION_DELETE_FAILED';
export const ACTION_PUBLISH_SUCCEEDED = 'ACTION_PUBLISH_SUCCEEDED';
export const ACTION_PUBLISH_FAILED = 'ACTION_PUBLISH_FAILED';
export const ACTION_SAVE_SUCCEEDED = 'ACTION_SAVE_SUCCEEDED';
export const ACTION_SAVE_PARTIALLY_SUCCEEDED =
  'ACTION_SAVE_PARTIALLY_SUCCEEDED';
export const ACTION_SAVE_FAILED = 'ACTION_SAVE_FAILED';

// Form States
export const FORM_ACTION_EVENT_EMITTED = 'FORM_ACTION_EVENT_EMITTED';
export const FORM_ACTION_FAILED = 'FORM_ACTION_FAILED';
export const FORM_DELETE_FAILED = 'FORM_DELETE_FAILED';
export const FORM_INITIALIZED = 'FORM_INITIALIZED';
export const FORM_SAVING = 'FORM_SAVING';
export const FORM_SAVE_SUCCEEDED = 'FORM_SAVE_SUCCEEDED';
export const FORM_SAVE_PARTIALLY_SUCCEEDED = 'FORM_SAVE_PARTIALLY_SUCCEEDED';
export const FORM_SAVE_FAILED = 'FORM_SAVE_FAILED';
export const FORM_PUBLISHING = 'FORM_PUBLISHING';
export const FORM_PUBLISH_FAILED = 'FORM_PUBLISH_FAILED';
export const FORM_PUBLISH_SUCCEEDED = 'FORM_PUBLISH_SUCCEEDED';

// PIDs reserve
export const RESERVE_PID_STARTED = 'RESERVE_PID_STARTED';
export const RESERVE_PID_SUCCESS = 'RESERVE_PID_SUCCESS';
export const RESERVE_PID_FAILED = 'RESERVE_PID_FAILED';

// PIDs discard
export const DISCARD_PID_STARTED = 'DISCARD_PID_STARTED';
export const DISCARD_PID_SUCCESS = 'DISCARD_PID_SUCCESS';
export const DISCARD_PID_FAILED = 'DISCARD_PID_FAILED';
